<template>
  <div class="page flex-v">
    <HeaderNav :posNavs="posNavs" :topLevel="true"/>
    <div class="container flex">
      <Sider :type="isDetail ? 2 : 1">
        <CommNav v-if="!isDetail" :navList="navList" :actId="1" @itemClick="navItemClick" />
      </Sider>
      <div class="layout-right">
        <ScrollBar ref="scrollbar" v-if="loaded" class="scrollbar main">
          <div class="wrap" :class="{'wrap-detail': isDetail, 'special': info.kind == 9, 'flex-v': !isHasCourse}">
            <div class="book-box">
              <dl class="info">
                <dt>
                  <img :src="info.detailCoverUrl">
                </dt>
                <dd>
                  <h2 v-text="info.name"></h2>
                  <div class="desc" v-text="info.subtitle"></div>
                  <div class="btns">
                    <button class="btn" @click="saveFav">
                      <i class="icon icon-btn-fav" :class="{'icon-faved': isFaved}"></i>
                      <span>{{isFaved ? '已收藏' :'收藏'}}</span>
                    </button>
                    <button @click.stop="buy" v-if="!getUserInfo.memberFlag" class="btn btn-subscribe">
                      <i class="icon icon-subscribe"></i>
                      <span>订阅</span>
                    </button>
                    <div class="buy-info" v-if="getUserInfo.memberFlag && !isOrga"><i class="icon icon-gou"></i>会员有效期{{getUserInfo.memberBeginDateOutput}}至{{getUserInfo.memberEndDateOutput}}</div>
                    <!--  <div class="buy-info" v-if="info.pcPrice<1"><i class="icon icon-gou"></i>可免费听读本图书所有章节</div> -->
                    <div class="count">共 {{count}} 篇</div>
                  </div>
                </dd>
              </dl>
              <div class="list">
                <div v-for="(item,index) in courseKinds" :key="item.id">
                  <CourseItem :index="index" :item="item" :isHasCourse="isHasCourse"></CourseItem>
                </div>
              </div>
            </div>
            <div class="press-box flex-v">
              <div class="no-data no-data-detail" v-if="loaded && !isHasCourse">
                <div>
                  <i class="icon icon-empty"></i>
                  <div class="tip">图书内容正在精心整理中</div>
                </div>
              </div>
              <div class="press" v-if="info.pressOutput">{{info.pressOutput}}</div>
            </div>
            <div class="book-right">
              <RightNav v-if="!isDetail" :selected="selectedItem" @itemClick="rightNavItemClick" title="教材选择" :navList="bookList" />
            </div>
          </div>
        </ScrollBar>
      </div>
    </div>
    <BuyBook ref='buyBook' />
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import util from 'libs/util'
import { bookNav } from '@/data/navData';
import CourseItem from 'business/CourseItem';
import BuyBook from 'business/BuyBook';

export default {
  components: {
    CourseItem,
    BuyBook
  },
  computed: {
    ...mapGetters([
      'getUserInfo'
    ])
  },
  data() {
    return {
      navList: bookNav,
      bookList: [],
      posNavs: [],
      courseKinds: [],
      isFaved: 0,
      loaded: 0,
      info: {},
      count: 0,
      isDetail: 0,
      isHasCourse: false,
      selectedItem: {
        id: ''
      },
      isOrga: false
    }
  },
  async created() {
    this.init();
    await this.$user.isLoginReady()
  },
  mounted() {
    this.isOrga = util.getStorage('orgaId') ? true : false
  },
  methods: {
    async init() {
      let query = this.$route.query;
      this.type = query.type || 1;
      this.id = query.id;
      if (this.type == 1) {
        await this.getTeachingmaterial();
      }
      if (this.type == 2) {
        this.id = query.id;
        this.isDetail = true
      } else {
        this.isDetail = false;
        this.id = this.selectedItem?.id || '';
        if(this.id)util.setStorage('LLSH_LAST_WARE', this.id);
      }
      this.getInfo();
      this.checkFavStatus();
    },
    async getInfo() {
      let query = this.$route.query;
      if (!this.isMounted) {
        this.$loading.show();
      }
      const params = {
        bookId: this.id
      }
      this.loaded = 0;
      const res = await this.$post('/book/info.json', params);
      if (res.status == 200) {
        let data = res.data || {};
        let count = 0;
        data = this.$getBookImg(data);
        const courseKinds = data.courseKinds || [];
        courseKinds.forEach((item) => {
          if (item.courseList) {
            item.courseList.forEach((c) => {
              this.isHasCourse = true;
              c = this.$getCourseImg(c);
              count++;
            })
          }
        });
        if (courseKinds.length < 1) {
          this.isHasCourse = false;
        }
        this.count = count;
        this.courseKinds = courseKinds;
        this.info = data;
        this.setPosNav();
        this.$nextTick(() => {
          this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true)
        })
      }
      this.isMounted = true;
      if (this.isMounted) {
        this.$loading.hide();
      }
      this.loaded = 1;
    },
    setPosNav() {
      let info = this.info;
      let posNavs = [{
        id: 1,
        name: '首页',
        pathName: 'index'
      }];
      if (this.isDetail) {
        posNavs.push({
          id: 2,
          name: '诵读资源',
          pathName: 'book_library'
        })
        posNavs.push({
          id: 3,
          name: info.name
        })
      } else {
        posNavs.push({
          id: 3,
          name: '语文教材'
        })
      }

      this.posNavs = posNavs;
    },
    async saveFav() {
      let url = '/book/favorite.json';
      if (this.isFaved) {
        url = '/book/unfavorite.json';
      }
      this.$user.checkIsLogin(async () => {
        const res = await this.$post(url, {
          bookId: this.id
        });
        if (res.status == 200) {
          this.isFaved = !this.isFaved;
          if (this.isFaved) {
            this.$toast('已收藏');
          } else {
            this.$toast('已取消收藏');
          }
        } else {
          this.$toast(res.message);
        }
      }, 2)
    },
    buy() {
      this.$refs.buyBook && this.$refs.buyBook.open();
    },
    async checkFavStatus() {
      if (this.$user.isLogin()) {
        const res = await this.$post('/book/favorite/status.json', {
          bookId: this.id
        });
        if (res.status == 200) {
          this.isFaved = res.data;
        }
      }
    },
    getTeachingmaterial() {
      return new Promise(async (resolve, reject) => {
        const res = await this.$post('/recommend/home/teachingmaterial/list.json', {});
        if (res.status == 200) {
          if (res.data) {
            let data = res.data;
            let list = data.objList || [];
            let selectedItem = {};
            if (this.type == 1 && !this.id && list.length) {
              selectedItem = list[0];
            } else {
              selectedItem = list.find(item => {
                return item.id == this.id;
              })
            }
            this.selectedItem = selectedItem;
            this.bookList = list || [];
          }
          resolve();
        }
      })
    },
    navItemClick(item) {
      this.$gopage(item.pathName, {}, true)
    },
    rightNavItemClick(item) {
      this.id = item.id;
      this.selectedItem = item;
      this.$gopage('book_ware', {
        id: this.id
      }, true);
      this.init();
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/book/detail.less';
</style>